import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import {
  GET_MY_CONTACTS_QUERY,
  GET_SITE_COLLABORATORS_QUERY,
} from '../../../gql';
import AccessGrid from './AccessGrid';

const pageStyles = { gap: 2 };
const descriptionStyles = { color: 'text.secondary' };

const SiteAccess = React.memo(() => {
  const { siteId } = useParams();

  const { data: contactsData, loading: contactsLoading } = useQuery(
    GET_MY_CONTACTS_QUERY,
    {
      fetchPolicy: 'cache-first',
    }
  );

  const { data: collaboratorsData, loading: collaboratorsLoading } = useQuery(
    GET_SITE_COLLABORATORS_QUERY,
    {
      variables: { siteId, pagination: { limit: 1000 } },
      fetchPolicy: 'cache-first',
    }
  );

  const contacts = contactsData?.getMyContacts?.contacts || [];
  const collaborators = collaboratorsData?.getSiteCollaborators || [];

  return (
    <Stack sx={pageStyles}>
      <div>
        <Typography component="h1" variant="h4">
          <FormattedMessage
            id="site.access.title"
            defaultMessage="Collaborator access"
          />
        </Typography>
        <Typography sx={descriptionStyles}>
          <FormattedMessage
            id="site.access.description"
            defaultMessage="Manage who can view and edit this site's finds."
          />
        </Typography>
      </div>
      <AccessGrid siteId={siteId} data={collaborators} contacts={contacts} />
    </Stack>
  );
});

export { SiteAccess };
